import React from 'react';
import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { ReactComponent as LogoSvg } from 'assets/images/logo.svg';

const useStyles = makeStyles((theme) => ({
  root: {
    height: theme.spacing(8),
    width: theme.spacing(18),
    marginBottom: theme.spacing(2),
  },
}));

function Logo({ className }) {
  const classes = useStyles();
  return (
    <LogoSvg className={clsx(classes.root, className)} />
  );
}

Logo.defaultProps = {
  className: null,
};

Logo.propTypes = {
  className: PropTypes.string,
};

export default Logo;
